module.exports = __webpack_public_path__ + "static/media/react.8ef5af1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/api_microservices/react.png
// module id = 106
// module chunks = 0